/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import circleAdapter from '../../_common/js/loading/circle-adapter.js';
import { getClassPrefixMixins } from '../../config-provider/config-receiver.js';
import mixins from '../../utils/mixins.js';
import '@babel/runtime/helpers/defineProperty';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import 'vue';
import 'lodash/mergeWith';
import '../../config-provider/context.js';
import 'lodash/merge';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '../../config-provider/type.js';

var classPrefixMixins = getClassPrefixMixins("loading");
var GradientIcon = mixins(classPrefixMixins).extend({
  name: "TLoadingGradient",
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.updateColor();
    });
  },
  updated: function updated() {
    this.updateColor();
  },
  methods: {
    updateColor: function updateColor() {
      var circleElem = this.$refs.circle;
      circleAdapter(circleElem);
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = ["".concat(this.classPrefix, "-loading__gradient"), "".concat(this.classPrefix, "-icon-loading")];
    return h("svg", {
      "class": classes,
      "attrs": {
        "viewBox": "0 0 14 14",
        "version": "1.1",
        "width": "1em",
        "height": "1em",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [h("foreignObject", {
      "attrs": {
        "x": "1",
        "y": "1",
        "width": "12",
        "height": "12"
      }
    }, [h("div", {
      "class": "".concat(this.classPrefix, "-loading__gradient-conic"),
      "ref": "circle"
    })])]);
  }
});

export { GradientIcon as default };
//# sourceMappingURL=gradient.js.map
